import '../applied_filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedInstagramPromotedFilterView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  template: JST["backbone/templates/monitoring/filters/published/applied_instagram_promoted_filter"]

  removeFilter: (value) ->
    @searchQuery.resetField('is_instagram_ad')

  getPromoted: ->
    @searchQuery.get('is_instagram_ad')

  hasFilterValue: ->
    @getPromoted() != undefined

  isPromoted: ->
    @getPromoted() == true
